import React, { useEffect, useMemo, useState } from 'react';
import PopUp from '../../components/PopUp';
import { TextInput, Select } from '@mantine/core';
import { ModelDetailPopUpProps } from '../../types/models';
import sorterStyles from '../sorters/SorterPage.module.css'
import { ModelsDetailRowType } from "../../types/models"
import { useCategories } from '../../context/CategoriesContext';

//TODO: options mutiselect!!
const MAX_MODEL_LABEL = 2147483647;

const ModelsDetailsPopUp = ({ opened, close, title, onSave, modelLabel, activeTab, existingModelLabels }: ModelDetailPopUpProps) => {
    const { recyclingCat, reuseCat, colorCat } = useCategories();
    const [booleanExpression, setBooleanExpression] = useState<string>('');
    const [category, setCategory] = useState<number>(0);
    const [order, setOrder] = useState<number>(0);
    const [modelLabelId, setModelLabelId] = useState<string>('');
    const [modelLabelError, setModelLabelError] = useState<string>('');
    const [categoryError, setCategoryError] = useState<string>('');

    useEffect(() => {
        setBooleanExpression(modelLabel?.boolean_expression || '');
        setCategory(modelLabel?.reuse_category_id || modelLabel?.recycling_category_id || modelLabel?.color_id || 0);
        setOrder(modelLabel?.order || 0);
        setModelLabelId(modelLabel?.model_label !== undefined ? String(modelLabel.model_label) : '');
        setModelLabelError('');
        setCategoryError('');
    }, [opened, modelLabel]);

    const labelInUse = useMemo(() => {
        const parsed = Number(modelLabelId);
        if (!Number.isInteger(parsed)) {
            return false;
        }

        return existingModelLabels.some((label) => {
            if (modelLabel?.id !== undefined && modelLabel?.model_label === parsed) {
                return false;
            }
            return label === parsed;
        });
    }, [existingModelLabels, modelLabel?.id, modelLabel?.model_label, modelLabelId]);

    const handleBooleanExpressionChange = (value: string) => {
        setBooleanExpression(value);
    };

    const handleCategoryChange = (value: string | null) => {
        const numVal = value ? Number(value) : 0;
        setCategory(numVal);
        if (!value || numVal <= 0) {
            setCategoryError('Category is required.');
        } else {
            setCategoryError('');
        }
    };

    const handleOrderChange = (value: number) => {
        setOrder(value);
    };

    const handleModelLabelIdChange = (value: string) => {
        setModelLabelId(value);
        const trimmed = value.trim();

        if (!trimmed) {
            setModelLabelError('Model label is required.');
            return;
        }

        if (!/^\d+$/.test(trimmed)) {
            setModelLabelError('Only numeric characters are allowed.');
            return;
        }

        const parsed = Number(trimmed);
        if (parsed > MAX_MODEL_LABEL) {
            setModelLabelError(`Model label must be <= ${MAX_MODEL_LABEL}.`);
            return;
        }

        if (existingModelLabels.includes(parsed) && modelLabel?.model_label !== parsed) {
            setModelLabelError('Model label already exists in this model.');
        } else {
            setModelLabelError('');
        }
    }

    const onSaveHandler = () => {
        const trimmedModelLabel = modelLabelId.trim();

        if (!trimmedModelLabel) {
            setModelLabelError('Model label is required.');
            return;
        }

        if (!/^\d+$/.test(trimmedModelLabel)) {
            setModelLabelError('Only numeric characters are allowed.');
            return;
        }

        const parsedModelLabel = Number(trimmedModelLabel);
        if (parsedModelLabel > MAX_MODEL_LABEL) {
            setModelLabelError(`Model label must be <= ${MAX_MODEL_LABEL}.`);
            return;
        }

        if (labelInUse) {
            setModelLabelError('Model label already exists in this model.');
            return;
        }

        if (!category || category <= 0) {
            setCategoryError('Category is required.');
            return;
        }

        const newCategory: ModelsDetailRowType = {
            id: modelLabel?.id || undefined,
            sorter_model_id: modelLabel?.sorter_model_id || 0,
            model_label: modelLabel?.model_label || parsedModelLabel,
            recycling_category_id: activeTab === "Recycling" ? category : undefined,
            reuse_category_id: activeTab === "Reuse" ? category : undefined,
            color_id: activeTab === "Color" ? category : undefined,
            deleted: modelLabel?.deleted || false,
            boolean_expression: activeTab === "Recycling" ? booleanExpression : undefined,
            order: activeTab === "Recycling" ? order : undefined
        };
        console.log("onSaveHandler", newCategory);
        onSave(newCategory);
        close();
    };

    // Get categories depending on activeTab
    const getCategoryOptions = () => {
        let list: any[] = [];
        if (activeTab === 'Recycling') {
            list = recyclingCat;
        } else if (activeTab === 'Reuse') {
            list = reuseCat;
        } else if (activeTab === 'Color') {
            list = colorCat;
        }
        return list.map((cat: any) => ({
            value: String(cat.id),
            label: cat.name,
        }));
    };

    return (
        <PopUp opened={opened} close={close} title={title} onSave={onSaveHandler} >

            <div className={sorterStyles.PopupInputs}>
                {title === "Edit" && (
                    <TextInput
                        label="Model Label"
                        value={String(modelLabel?.model_label)}
                        disabled={true}
                    />
                )}
                {title === "Add" && (
                    <TextInput
                        label="Model Label" 
                        value={String(modelLabelId)}
                        onChange={(event) => handleModelLabelIdChange(event.currentTarget.value)}
                        error={modelLabelError}
                    />
                )}
            </div>


            {activeTab === "Recycling" && <TextInput label="Boolean Expression" value={booleanExpression} placeholder={modelLabel?.boolean_expression || ''} onChange={(event) => handleBooleanExpressionChange(event.currentTarget.value)} />}
            
            <Select
                label="Category"
                placeholder="Pick category"
                data={getCategoryOptions()}
                value={category !== 0 ? String(category) : null}
                onChange={handleCategoryChange}
                error={categoryError}
                searchable
            />
            {activeTab === "Recycling" && <TextInput label="Order" value={order} placeholder={modelLabel?.order?.toString() || ''} onChange={(event) => handleOrderChange(Number(event.currentTarget.value))} />}
        </PopUp>
    )
}
export default ModelsDetailsPopUp;